import { render, staticRenderFns } from "./BrokerReportWillsGraph.vue?vue&type=template&id=323b94d4"
import script from "./BrokerReportWillsGraph.vue?vue&type=script&lang=js"
export * from "./BrokerReportWillsGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports